module.exports = __webpack_public_path__ + "static/media/uber.7003bfac.svg";